module.exports = __webpack_public_path__ + "img/535F6B_A6BDC8_8FA3B4_7F91A2-256px.607eade8.png";